import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative flex h-[520px] w-full items-center md:h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20theatre%20stage%20with%20dramatic%20crimson%20and%20amber%20spotlights%2C%20silhouettes%20of%20empty%20seats%2C%20volumetric%20light%20beams%20through%20haze%2C%20dark%20moody%20atmosphere%2C%20stylized%20editorial%20background%20with%20strong%20contrast%20for%20text%20overlay&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape"
          alt="18爆料网首屏背景 - 舞台聚光灯意象"
          title="18爆料网 - 娱乐热点观察"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/30" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1 text-xs tracking-[0.2em] text-accent-300">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
            ENTERTAINMENT · 每日更新
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            {siteInfo.name}
          </h1>
          <p className="mt-4 font-heading text-lg text-accent-300 md:text-2xl">
            {siteInfo.slogan}
          </p>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base md:leading-8">
            从明星塌房现场直击，到艺人黑历史与娱乐圈内幕的持续深挖，我们把碎片化的热点整理成清晰的时间线。
            每天都有新瓜吃，但更希望你吃明白。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-fire-line text-lg"></i>
              查看今日热榜
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
            >
              <i className="ri-layout-grid-line text-lg"></i>
              浏览全部栏目
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-4 border-t border-background-50/20 pt-6 sm:grid-cols-4">
            {siteInfo.stats.map((s) => (
              <div key={s.label}>
                <dt className="text-xs text-background-300">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl font-black text-background-50 md:text-2xl">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}